import { Time } from '@angular/common';
import { LieuDTO } from './dto/activity-session';

export class Activity {
  constructor(
    public nomActivity: string,
    public activityType: String,
    public description: String,
    public openDate: Date,
    public closeDate: Date,
    public adresse: String,
    public testType?: String,
    public accessLink?: String,
    public hours?: Time,
    public isPublic?: Boolean,
    public sousListe?: number,
    public listCertificats?: number[],
    public idCertificat?: number,
    public nomCertif?: string,
    public createdBy?: String,
    public createdAt?: Date,
    public updatedAt?: Date,
    public listeParticipants?: any[],
    public id?: number,
    public residenceZones?: any[],
    public cohort?: string,
    public cohorts?: string[],
    public bootcampLink?: string,
    public composante?: string,
    public listPersonnel?: string[],
    public isClosed?: boolean,
    public countryId?: number,
    public lieux?: LieuDTO[],
    public countryFlag?: string,
  ) {}
}
